import { ThunkApiType } from 'types/utils';

export const healthCheckThunk = async (_: string, thunkAPI: ThunkApiType) => {
	try {
		const response = await fetch(process.env.REACT_APP_CHECK_VPN_URL!);
		const checkBackend = await response.json();

		return checkBackend
			? true
			: thunkAPI.rejectWithValue({ response: 'dead ;(' });
	} catch (error: ThunkApiType) {
		return thunkAPI.rejectWithValue({ response: 'dead ;(' });
	}
};
